// extracted by mini-css-extract-plugin
export var content = "_54-3";
export var list = "_54-4";
export var settingsContent = "_54-7";
export var settingsPanel = "_54-8";
export var state = "_54-6";
export var triggerBadge = "_54-2";
export var triggerButton = "_54-1";
export var triggerShell = "_54-0";
export var unreadDot = "_54-5";